export default {
      id: "about-symbols-08-usage",
      viewBox: "0 0 150 150",
      url: "/" + "sprite.svg#about-symbols-08",
      toString: function () {
        return this.url;
      }
    }